export default __webpack_public_path__ + "static/media/lovrican-badge.2f47bc7f.svg";